export default {
  location: {
    pathname: "/",
  },
};
